import $ from 'jquery'

export default {
	twoWay: true,
	params: ['tags', 'placeholder'],

	bind() {
		let self = this;

		$(this.el).select2({
			tags: this.params.tags,
			placeholder: this.params.placeholder,
			allowClear: false
		}).on('change', function () {
			self.set(this.value);
		});
	},

	update(value) {
		$(this.el).val(value).trigger('change')
	},

	unbind() {
		$(this.el).off().select2('destroy')
	}
}



// WEBPACK FOOTER //
// ./src/directives/select2.js